<template>
    <v-card class="pa-0 border border-transparent" outlined>
        <v-tabs
                v-model="tab"
                background-color="orange lighten-2"
                dark
                fixed-tabs
        >
            <v-tab class="product-tab" :href="'#description'">{{ getTabTitle(this.typeDescription) }}</v-tab>
            <v-tab class="product-tab" :href="'#specifications'">{{ getTabTitle(this.typeSpecifications) }}</v-tab>
            <v-tab class="product-tab" :href="'#feedback'">{{ getTabTitle(this.typeFeedback) }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pb-7" next-icon prev-icon>
            <v-tab-item
                :value="'description'"
            >
                <v-col xs="12">
                    <v-card flat>
                        <v-card-title>
                            <span>{{ productName }}</span>
                        </v-card-title>
                        <div :class="{'description-box': isHiddenDescription}" ref="description-box">
                            <v-card-text v-html="productDescription" class="product-description ck-content"></v-card-text>
                            <div class="clearfix"></div>
                            <p class="read-more text-center ma-0" v-if="productDescription">
                                <v-btn
                                    depressed
                                    :text="isHiddenDescription"
                                    :dark="!isHiddenDescription"
                                    :class="{'main--yellow': !isHiddenDescription}"
                                    @click="isHiddenDescription = !isHiddenDescription"
                                >
                                    {{ $t(isHiddenDescription ? 'readMore' : 'collapse') }}
                                </v-btn>
                            </p>
                        </div>
                    </v-card>
                </v-col>
            </v-tab-item>
            <v-tab-item
                :value="'specifications'"
            >
                <v-col sm="10" md="10" lg="10">
                    <v-card flat>
                        <v-card-title>{{ $t('productParams') }}</v-card-title>
                        <v-card-text>
                            <v-row
                                v-for="specification in productAttributes.enumAttributes"
                                v-if="specification.system_name !== manufacturerAttributeName"
                                :key="specification.name"
                                class="d-flex align-baseline pa-0"
                                dense
                            >
                                <v-col cols="6" sm="5" class="py-0">
                                    <div class="subtitle-1 black--text">{{specification.name}}</div>
                                </v-col>
                                <v-col cols="6" sm="7" class="py-0">
                                    <div class="body-2" v-if="!specification.has_numeric_attributes">
                                        <template
                                            v-if="!specification.items.parents.length"
                                            v-for="(item, idx) in specification.items.values"
                                        >
                                            <component
                                                :key="item.value"
                                                :is="getTag(item.system_name)"
                                                :to="getLink(specification.system_name, item.system_name)"
                                                :class="{'text-underline': item.system_name}"
                                            >
                                                {{ item.value.toLowerCase() }}
                                            </component>
                                            {{ getLastSymbol(specification.items.values, idx) }}
                                        </template>
                                        <template>
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <tbody>
                                                        <template v-for="(parent, idx) in specification.items.parents">
                                                            <tr>
                                                                <td class="pl-0 table-col">{{parent.value.toLowerCase()}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="pl-0 table-col half-width">
                                                                    <template
                                                                        v-for="(item, idx) in getValuesByParentId(specification.items.values, parent.value_id)"
                                                                    >
                                                                        <component
                                                                            :key="item.parent_id + item.value"
                                                                            :is="getTag(item.system_name)"
                                                                            :to="getLink(specification.system_name, item.system_name)"
                                                                            :class="{'text-underline': item.system_name}"
                                                                        >
                                                                            {{ item.value.toLowerCase() }}
                                                                        </component>
                                                                        {{ getLastSymbol(getValuesByParentId(specification.items.values, parent.value_id), idx) }}
                                                                    </template>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </template>
                                    </div>
                                    <div v-if="specification.has_numeric_attributes">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <tbody>
                                                <tr
                                                    v-for="(item, idx) in specification.items.values"
                                                    :key="idx"
                                                    class="table-row"
                                                >
                                                    <td class="pl-0 table-col half-with">
                                                        <component
                                                            class="numeric-values"
                                                            :key="item.parent_id + item.value"
                                                            :is="getTag(item.system_name)"
                                                            :to="getLink(specification.system_name, item.system_name)"
                                                            :class="{'text-underline': item.system_name}"
                                                        >
                                                            {{ item.value.name.toLowerCase() }}
                                                        </component>
                                                    </td>
                                                    <td class="table-col half-width"><span class="numeric-values">{{ item.value.numeric }}</span></td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                                </v-col>
                                <v-col cols="12">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <div class="title d-flex justify-md-start justify-center text-center text-md-start pa-4">
                        {{ $t('feedbackMore') }} {{ $t('aboutProduct') }} {{ productName }}
                    </div>
                    <div v-if="!productFeedbacks.length" class="py-6">
                        <div class="text-center py-6 text-uppercase font-italic grey--text text--darken-1 text-h4">
                            {{ $t('noFeedbacksProduct') }}
                        </div>
                        <div class="text-center py-6">
                            <v-btn text class="text--main-yellow" @click="$emit('feedback')">
                                {{ $t('writeSellerFeedback') }}
                            </v-btn>
                        </div>
                    </div>
                    <v-card
                        v-for="(feedback,i) in productFeedbacks"
                        :key="i"
                        class="br-10 mb-6 mx-4"
                        outlined
                    >
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-card-text class="d-flex justify-center caption pt-0">{{ feedback.createdAt }}</v-card-text>
                                <v-card-title class="d-flex justify-center py-0">{{ feedback.userName }}</v-card-title>
                            </v-col>
                            <v-col cols="12" md="9" class="">
                                <v-divider class="hidden-sm-and-up"></v-divider>
                                <div class="card-border-left">
                                    <v-card-text>{{ feedback.content }}</v-card-text>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import Auth from "../../../app-front/mixins/Auth"

    export default {
        name: "Characteristics",
        props: ['productData', 'productFeedbacks'],
        mixins: [Auth],
        data() {
            return {
                manufacturerAttributeName: 'proizvoditel',
                tab: null,
                typeDescription: 1,
                typeSpecifications: 2,
                typeFeedback: 3,
                tabs: [],
                paymentTabContent: null,
                isHiddenDescription: true,
            }
        },
        computed: {
            productAttributes() {
                return this.productData.attributes || [];
            },
            productDescription() {
                return this.productData.productDescription || '';
            },
            productName() {
                return this.productData.productName || '';
            },
        },
        methods: {
            setTabs() {
                this.tabs = [
                    { title: this.$t('description'), type: this.typeDescription },
                    { title: this.$t('characteristics'), type: this.typeSpecifications },
                    { title: this.$t('paymentMethod'), type: this.typePayment },
                    { title: this.$t('feedbackMore'), type: this.typeFeedback }
                ]
            },
            getTabTitle(type) {
                const tab = this.tabs.find(item => item.type === type)

                return tab ? tab.title : ''
            },
            getValuesByParentId(values, id) {
                return values.filter(value => value.parent_id === id);
            },
            getLastSymbol(array, idx) {
                return idx !== array.length - 1 ? ', ' : '';
            },
            getTag(systemName) {
                return systemName ? 'router-link' : 'span';
            },
            getLink(parentSystemName, systemName) {
                return systemName ? `/products/attribute/${parentSystemName}/${systemName}` : null;
            },
            unsetQueryParam() {
                if(this.$route.query.tab) {
                    let query = Object.assign({}, this.$route.query);
                    delete query.tab;
                    this.$router.replace({ query });
                }
            },
            getValData(data) {
                try {
                    console.log(data, 1);
                    return data.value.toLowerCase();
                } catch (e) {
                    console.log(data, 2)
                    return '';
                }
            }
        },
        created() {
            this.setTabs();
        },
        watch: {
            isHiddenDescription(value) {
                if (value) {
                    const bodyRect = document.body.getBoundingClientRect();
                    const elementRect = this.$refs['description-box'].getBoundingClientRect()

                    if (elementRect.top < 0) {
                        window.scrollTo({
                            top: elementRect.top - bodyRect.top - 50
                        })
                    }
                }
            },
            productData(val) {
                this.tab = (this.$route.query.tab === 'feedback') ? 'feedback' : 'description';
                this.unsetQueryParam()
            }
        },
    }
</script>

<style scoped>
    .clearfix::after {
        display: block;
        content: "";
        clear: both;
    }
    .v-tab {
        color: rgba(255, 255, 255, 0.6) !important;
    }
    .v-tab--active {
        color: rgb(255, 255, 255) !important;
    }
    .table-row {
        background-color: #fefefe;
    }
    .table-col {
        height: 25px !important;
    }
    .numeric-values {
        color: rgba(0,0,0,.6);
    }
    .description-box {
        max-height: 250px;
        position: relative;
        overflow: hidden;
    }
    .description-box .read-more {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-top: 60px;
        background-image: linear-gradient(to bottom, transparent, white);
    }
    .half-width {
        width: 50%;
    }
    .card-border-right {
        border-right: rgba(0, 0, 0, 0.12) solid 1px !important;
    }
    .card-border-left {
        border-left: rgba(0, 0, 0, 0.12) solid 1px !important;
    }
    /*Mobile version*/
    @media screen and (max-width: 800px) {
        .company-image {
            width: 100px;
            height: 100px;
        }
        .card-border-right {
            border-right: transparent solid 1px !important;
        }
        .card-border-left {
            border-left: transparent solid 1px !important;
        }
    }
</style>
